import Button from 'components/Button/Button';
import useBroadcastChannel from 'hooks/useBroadcastChannel';
import React from 'react';

export default function ErrorPage({ message }: { message?: string }) {
  const { postBroadcastMessage } = useBroadcastChannel();

  return (
    <main className="u-flex-center">
      <div className="container">
        <h1>Sorry, there&apos;s been an error.</h1>
        <h3>{message}</h3>
        <br />
        <a href="/">Return To Homepage</a>
        <br />
        <br />
        <Button onClick={() => postBroadcastMessage('broadcast_signout')}>Signout</Button>
      </div>
    </main>
  );
}
